'use client';

import { Button, cn } from '@shared/components/shadcn';
import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';
import type { UseEducationalTutorialReturn } from '../../hooks/useEducationalTutorial';

type EducationalTutorialActionsProps = ComponentProps<'div'> & {
  tutorial: UseEducationalTutorialReturn;
};

function EducationalTutorialActions({ tutorial, className, ...props }: EducationalTutorialActionsProps) {
  const t = useTranslations('global_dialogs.educational');

  return (
    <div className={cn('flex gap-2', className)} role="group" aria-label={t('accessibility.navigation_controls')} {...props} data-track-container="Actions">
      {!tutorial.isFirstStep && (
        <Button
          // eslint-disable-next-line react-hooks/refs
          ref={tutorial.previousButtonRef}
          variant="secondary"
          size="s"
          // eslint-disable-next-line react-hooks/refs
          onClick={tutorial.handlePrevious}
          data-track-name="Back"
          // eslint-disable-next-line react-hooks/refs
          aria-label={tutorial.previousButtonAriaLabel}
        >
          {t('actions.previous')}
        </Button>
      )}
      <Button
        // eslint-disable-next-line react-hooks/refs
        ref={tutorial.nextButtonRef}
        variant="primary"
        size="s"
        // eslint-disable-next-line react-hooks/refs
        onClick={tutorial.handleNext}
        data-track-name="Continue"
        // eslint-disable-next-line react-hooks/refs
        aria-label={tutorial.nextButtonAriaLabel}
      >
        {
          // eslint-disable-next-line react-hooks/refs
          tutorial.nextButtonText
        }
      </Button>
    </div>
  );
}

export { EducationalTutorialActions };
